<template>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <div
            class="text-sm text-center copyright text-muted"
            :class="this.$store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          >
            © TWL-KOM GmbH
            {{ new Date().getFullYear() }}
          </div>
        </div>
        <div class="col-lg-6">
          <ul
            class="nav nav-footer justify-content-center justify-content-lg-end"
          >
            <li class="nav-item">
              <a
                href="https://twl-kom.de/kontakt"
                class="nav-link text-muted"
                target="_blank"
                >Kontakt</a
              >
            </li>
            <li class="nav-item">
              <a
                href="https://twl-kom.de/agb"
                class="nav-link text-muted"
                target="_blank"
                >AGB</a
              >
            </li>
            <li class="nav-item">
              <a
                href="https://twl-kom.de/datenschutz"
                class="nav-link text-muted"
                target="_blank"
                >Datenschutz</a
              >
            </li>
            <li class="nav-item">
              <a
                href="https://twl-kom.de/impressum"
                class="nav-link pe-0 text-muted"
                target="_blank"
                >Impressum</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>
